/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierClaimNoticeTrigger {
  Manual = "manual",
  Automatic = "automatic",
}

export function instanceOfCarrierClaimNoticeTrigger(value: any): boolean {
  for (const key in CarrierClaimNoticeTrigger) {
    if (Object.prototype.hasOwnProperty.call(CarrierClaimNoticeTrigger, key)) {
      if (
        CarrierClaimNoticeTrigger[
          key as keyof typeof CarrierClaimNoticeTrigger
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierClaimNoticeTriggerFromJSON(
  json: any,
): CarrierClaimNoticeTrigger {
  return CarrierClaimNoticeTriggerFromJSONTyped(json, false);
}

export function CarrierClaimNoticeTriggerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierClaimNoticeTrigger {
  return json as CarrierClaimNoticeTrigger;
}

export function CarrierClaimNoticeTriggerToJSON(
  value?: CarrierClaimNoticeTrigger | null,
): any {
  return value as any;
}

export function CarrierClaimNoticeTriggerToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierClaimNoticeTrigger {
  return value as CarrierClaimNoticeTrigger;
}
